/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
var _ = require("ES/lib/lodash");
var dd = require("ES/lib/dd");
var radio = require("ES/lib/radio");
var Modal = require("ES/widgets/Modal");
var esUtils = require("ES/utils/esUtils");
var Constants = require("../../../../../utils/Constants");
var RadioMixin = require("ES/utils/RadioMixin");
var ErrorAlert = require("ES/widgets/ErrorAlert");
var LoadingWrap = require("ES/widgets/LoadingWrap");
var AuthedUserSession = require("../../../../../utils/AuthedUserSession");
var getSpeakersFromDisplaylists = require("../../../../../utils/getSpeakersFromDisplaylists");

var StoredFileModal = require("./StoredFileModal");

module.exports = dd.createClass({
  getInitialState: function () {
    return {
      file_id_editing: null,
      file_id_deleting: null,
      file_id_merging: null,
      show_placeholder_codes: false,
    };
  },
  __toggleShowPlaceholderCodes: esUtils.wrapPreventDefault(function () {
    this.setState({
      show_placeholder_codes: !this.state.show_placeholder_codes,
    });
  }),
  __clickDelete: function (id) {
    var self = this;
    return esUtils.wrapPreventDefault(function () {
      self.setState({ file_id_deleting: id });
    });
  },
  __setEditingId: function (id) {
    var self = this;
    return esUtils.wrapPreventDefault(function () {
      self.setState({ file_id_editing: id });
    });
  },
  __clickMerge: function (id) {
    var self = this;
    return esUtils.wrapPreventDefault(function () {
      self.setState({ file_id_merging: id });
    });
  },
  render: function () {
    let { event, Displaylists } = this.props;
    let show_placeholder_codes = this.state.show_placeholder_codes;
    let templates = [];
    let template_ids_can_manage = [];

    if (AuthedUserSession.is_st_family) {
      template_ids_can_manage = []; //only managed through team admin
      templates = _.get(Displaylists, ["sitelists", "templates"], []);
      templates = _.sortBy(templates, ["description"]);
    } else {
      let my_template_ids = _.uniq(
        _.flattenDeep(
          _.map(
            getSpeakersFromDisplaylists(Displaylists, event.sids),
            "templatefile_ids"
          )
        )
      );
      let all_templatefiles_by_id =
        esUtils.getIn(Displaylists, ["speaker_shared", "templatefiles"]) || {};
      templates = _.sortBy(
        _.uniq(
          _.compact(
            _.map(my_template_ids, function (id) {
              return all_templatefiles_by_id[id];
            })
          ),
          "id"
        ),
        function (template) {
          return template.description.trim().toLowerCase();
        }
      );

      let sids_can_manage = _.intersection(
        event.sids,
        AuthedUserSession.doIHaveAccess.admin.getSIDs()
      );
      template_ids_can_manage = _.filter(
        _.uniq(
          _.flattenDeep(
            _.map(
              getSpeakersFromDisplaylists(Displaylists, sids_can_manage),
              "templatefile_ids"
            )
          )
        ),
        function (id) {
          let template_sids =
            all_templatefiles_by_id[id] && all_templatefiles_by_id[id].sids;
          return !_.isEmpty(_.intersection(template_sids, sids_can_manage));
        }
      );
    }

    let panelStyle = AuthedUserSession.is_st_family
      ? { maxHeight: "25em", overflowY: "auto" }
      : {};

    return dd.div(
      { className: "Library" },
      dd.a(
        {
          href: "#",
          className: "pull-right printlink",
          onClick: this.__toggleShowPlaceholderCodes,
        },
        "view placeholder codes"
      ),
      dd.h4(
        {
          className: "section-head",
          style: { marginBottom: "1em", marginTop: 25 },
        },
        "Template Library"
      ),
      dd.div(
        { style: panelStyle },
        dd.table(
          {
            className:
              "table table-responsive table-condensed table-hover Templates",
            style: { marginBottom: 10 },
          },
          dd.tbody(
            null,
            _.map(
              templates,
              function (template, i) {
                let can_manage = _.includes(
                  template_ids_can_manage,
                  template.id
                );
                return dd.tr(
                  { key: i, className: "template" },
                  dd.td(
                    {
                      className: "clickable" + (!can_manage ? " common" : ""),
                      onClick: this.__clickMerge(template.id),
                    },
                    dd.i({
                      className:
                        "file-icon fa " +
                        Constants.getFileTypeIcon(template.url),
                    }),
                    template.description
                  ),
                  dd.td(
                    { style: {} },
                    can_manage
                      ? dd.a(
                          {
                            href: "#",
                            onClick: this.__setEditingId(template.id),
                          },
                          dd.i({ className: "fa fa-pencil" })
                        )
                      : null
                  ),
                  dd.td(
                    { style: {} },
                    can_manage
                      ? dd.a(
                          {
                            href: "#",
                            onClick: this.__clickDelete(template.id),
                          },
                          dd.i({ className: "fa fa-times" })
                        )
                      : null
                  ),
                  dd.td(
                    { style: {} },
                    dd.button(
                      {
                        className: "btn btn-default btn-sm pull-right",
                        onClick: this.__clickMerge(template.id),
                      },
                      "merge"
                    )
                  )
                );
              },
              this
            ),
            _.isEmpty(templates) === 0
              ? dd.tr(
                  null,
                  dd.td(
                    { colSpan: 4 },
                    dd.div({ className: "text-center" }, "-- no templates --")
                  )
                )
              : null
          )
        )
      ),
      AuthedUserSession.doIHaveAccess.admin.any(event.sids)
        ? dd.div(
            { style: { marginTop: "1em" } },
            dd.button(
              {
                className: "btn btn-default btn-sm pull-right",
                onClick: this.__setEditingId(0),
              },
              dd.i({ className: "fa fa-file-o" }),
              " Add Template"
            ),
            dd.div({ className: "clearfix" })
          )
        : null,
      dd.div({ className: "clearfix", style: { height: 20 } }),

      //modals
      show_placeholder_codes
        ? PlaceholderCodesModal({
            onClose: this.__toggleShowPlaceholderCodes,
            Displaylists: Displaylists,
          })
        : null,
      this.state.file_id_editing !== null
        ? StoredFileModal({
            //Don't pass event, b/c this is event-less (if you pass it it'll attach the file to the event, not as a template)
            sids_to_apply_to: event.sids,
            Displaylists: Displaylists,
            file_id: this.state.file_id_editing,
            onClose: this.__setEditingId(null),
          })
        : null,
      this.state.file_id_deleting > 0
        ? DeleteTemplateModal({
            sids_to_apply_to: event.sids,
            file_id: this.state.file_id_deleting,
            onClose: this.__clickDelete(null),
          })
        : null,
      this.state.file_id_merging > 0
        ? MergeTemplateModal({
            event_id: event && event.eid,
            file_id: this.state.file_id_merging,
            onClose: this.__clickMerge(null),
          })
        : null
    );
  },
});

var PlaceholderCodesModal = dd.createClass({
  __onCopy: esUtils.wrapPreventDefault(function (e) {
    let textArea = document.createElement("textarea");
    textArea.value = e.target.textContent;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();

    this.setState({ copySuccess: true, copyKey: e.target.textContent }); //the copyKey re-triggers animation
  }),
  render: function () {
    let placeholdercodes =
      esUtils.getIn(this.props, [
        "Displaylists",
        "universal",
        "placeholdercodes",
      ]) || [];
    placeholdercodes = _.map(placeholdercodes, function (k, v) {
      return { code: v, description: k };
    });
    placeholdercodes = _.sortBy(placeholdercodes, "description");

    var me = this;
    return Modal(
      {
        title: "Placeholder Codes",
        onClose: this.props.onClose,
      },
      dd.div(
        { className: "alert" },
        dd.p(
          {},
          "Create template documents using Word (.docx) and Excel (.xlsx)."
        ),
        dd.p(
          {},
          'Placeholder codes in template documents are replaced with data from the event during the merge. "xxxx" values in SERVICE and CONTACT placeholders match on those items\' group codes.'
        ),
        dd.p(
          {},
          "More information about using placeholders in template documents is available ",
          dd.a(
            {
              href: "https://www.espeakers.com/wiki/Library_template_creation_instructions_(using_Placeholder_codes)",
              target: "_blank",
            },
            "here"
          ),
          "."
        )
      ),
      dd.div(
        { style: { maxHeight: "20em", overflowY: "scroll" } },
        dd.table(
          { className: "table table-responsive table-condensed" },

          dd.thead(
            null,
            dd.tr(
              null,
              dd.th({ style: { width: 1 } }, "Code"),
              dd.th(null, "Description")
            )
          ),
          dd.tbody(
            null,
            _.map(_.sortBy(placeholdercodes, "description"), function (o, i) {
              return dd.tr(
                { key: i },
                dd.td(
                  null,
                  dd.span(
                    {
                      className: "code",
                      onClick: me.__onCopy,
                      dataCode: _.get(o, "code"),
                    },
                    "[[" + _.get(o, "code") + "]]"
                  )
                ),
                dd.td(null, _.get(o, "description"))
              );
            })
          )
        )
      ),
      _.get(this.state, "copySuccess", false)
        ? dd.div(
            {
              key: _.get(this.state, "copyKey", ""),
              style: {
                color: "green",
                marginLeft: "1rem",
                marginTop: "0.5rem",
              },
              className: "fadein",
            },
            dd.i({
              className: "fa fa-clipboard",
              style: { marginRight: "0.5rem" },
            }),
            "copied"
          )
        : null
    );
  },
});

var DeleteTemplateModal = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return { deleting: false, error_msg: null };
  },
  componentWillMount: function () {
    var self = this;
    self.radio = {
      StoredFile_remove: function (eid, fileid) {
        if (fileid === self.props.file_id) {
          self.setState({ deleting: true, error_msg: null });
        }
      },
      StoredFile_remove_succeeded: function (eid, fileid, storedfiles) {
        if (fileid === self.props.file_id) {
          self.props.onClose();
        }
      },
      StoredFile_remove_failed: function (eid, fileid, message) {
        if (fileid === self.props.file_id) {
          self.setState({
            deleting: false,
            error_msg: "Failed to delete: " + message,
          });
        }
      },
    };
  },
  __delete: esUtils.wrapPreventDefault(function () {
    radio("StoredFile_remove").broadcast(
      -1,
      this.props.file_id,
      this.props.sids_to_apply_to
    );
  }),
  render: function () {
    var onClose = this.props.onClose;
    if (this.state.deleting) {
      return Modal(
        {
          title: "Deleting...",
          onClose: null,
          buttons: [],
        },
        LoadingWrap({ is_loading: true, text: "Deleting..." })
      );
    }
    if (this.state.error_msg) {
      return Modal(
        {
          title: "Error Deleting",
          onClose: onClose,
        },
        ErrorAlert({ message: this.state.error_msg })
      );
    }

    return Modal(
      {
        title: "Are you sure?",
        onClose: null,
        buttons: [],
      },
      dd.div(
        { className: "row" },
        dd.div(
          { className: "col-sm-3 text-muted text-center" },
          dd.i({ className: "fa fa-warning", style: { fontSize: 70 } })
        ),
        dd.div(
          { className: "col-sm-9" },
          dd.p(
            null,
            "Deleting a template affects all events for this speaker."
          ),
          dd.p(null, "Are you sure you want to delete it?")
        )
      ),
      dd.div(
        { className: "text-center" },
        dd.button(
          { className: "btn btn-danger", onClick: this.__delete },
          "Yes, delete"
        ),
        " ",
        dd.button(
          { className: "btn btn-default", onClick: onClose },
          "No, don't delete"
        )
      )
    );
  },
});

var MergeTemplateModal = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {
      merging: true, //right off the bat we'll start the merge
      error_msg: null,
      success_data: null,
    };
  },
  componentWillMount: function () {
    var self = this;
    self.radio = {
      MergeDocument: function (event_id, template_id) {
        if (
          self.props.event_id === event_id &&
          self.props.file_id === template_id
        ) {
          self.setState({ merging: true, error_msg: null, success_data: null });
        }
      },
      MergeDocument_succeeded: function (event_id, template_id, data) {
        if (
          self.props.event_id === event_id &&
          self.props.file_id === template_id
        ) {
          self.setState({
            merging: false,
            error_msg: null,
            success_data: data,
          });
        }
      },
      MergeDocument_failed: function (event_id, template_id, message) {
        if (
          self.props.event_id === event_id &&
          self.props.file_id === template_id
        ) {
          self.setState({
            merging: false,
            error_msg: message,
            success_data: null,
          });
        }
      },
    };
  },
  componentDidMount: function () {
    radio("MergeDocument").broadcast(this.props.event_id, this.props.file_id);
  },
  __clickDownload: esUtils.wrapPreventDefault(function (url) {
    window.location.assign(url);
    this.props.onClose();
  }),

  render: function () {
    var onClose = this.props.onClose;
    if (this.state.merging) {
      return Modal(
        {
          title: "Merging...",
          onClose: null,
          buttons: [],
        },
        LoadingWrap({ is_loading: true, text: "Merging..." })
      );
    }
    if (this.state.error_msg) {
      return Modal(
        {
          title: "Error Merging",
          onClose: onClose,
        },
        ErrorAlert({ message: this.state.error_msg })
      );
    }
    var data = this.state.success_data || {};

    return Modal(
      {
        title: "Done Merging",
        onClose: onClose,
        buttons: [],
      },
      dd.div(
        { className: "alert alert-success" },
        data.message || "Finished merging!"
      ),
      dd.div(
        { className: "text-center" },
        dd.p(null, data.outputfilename),
        dd.a(
          {
            className: "btn btn-primary",
            target: "_self",
            onClick: this.__clickDownload.bind(this, data.download_url),
          },
          dd.i({ className: "fa fa-download" }),
          " Download"
        )
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/library/TemplateLibrary.js